import "../JSONTools/JSONformatter.css";
import "./DBTools.css"
import ToolHeader from "../../Components/ToolHeader";
import { Row, Col } from "react-bootstrap";
import { useRef, useState, useEffect } from "react";
import { JSONtoSQL } from "../../Services/APIService";
import FormatterPanel from "../../HomePage/FormatterPanel";
import { ExampleJSON } from "../../Services/Tools";
import { InputHeaderButtons, OutputHeaderButtons } from "../JSONTools/JSONToolsHeaderButtons";
import { ReactComponent as CaretDownIcon } from "../../Icons/CaretDown.svg";



function JSONtoSQLConverter() {
    const [text, setText] = useState("");
    const [reqBody, setReqBody] = useState();
    const [result, setresult] = useState("")
    const indent = 2;
    const toolFav = { toolName: 'JSON to SQL', Iconpath: "/FileCodeRaw.svg" };
    const [tableName, setTableName] = useState("my_table");
    const [dialect, setDialect] = useState("MySQL");

    const [multiRow, setMultiRow] = useState(false);
    const [createTable, setCreateTable] = useState(false);
    const [includeColumns, setIncludeColumns] = useState(false);
    const dialectOptions = ["MySQL", "PostgreSQL", "SQLite", "MS SQL Server"];
    const [showDialectDropdown, setShowDialectDropdown] = useState(false);
    const dialectDropdownRef = useRef(null);

    

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                dialectDropdownRef.current &&
                !dialectDropdownRef.current.contains(event.target)
            ) {
                setShowDialectDropdown(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    



    const lineCount = text !== "" ? (text || "").split("\n").length : 0;
    const resultLineCount = result !== "" ? (result ?? "").toString().split("\n").length : 0;

    const handleChange = (e) => {
        const value = e.target.value;
        setText(value);
        setReqBody({
            tableName: tableName,
            json: value,
            dialect:dialect,
            multiRow: multiRow,
            includeColumns: includeColumns
        });

    };

    const handleTableNameChange = (value) => {
        setTableName(value);
        setReqBody({
            tableName: value,
            json: text,
            dialect:dialect,
            multiRow: multiRow,
            includeColumns: includeColumns
        });

    };

    const generateSQL = async () => {
        setresult("");

        try {
            const res = await JSONtoSQL(reqBody);
            setresult(res.data.sql);
        } catch (error) {
            const apiMessage =
                error.response?.data?.message ||
                error.message ||
                "Error generating SQL";

            setresult(apiMessage);
        }
    };

    const pasteExample = () => {
        const exampleText =
            typeof ExampleJSON === "string"
                ? ExampleJSON
                : JSON.stringify(ExampleJSON, null, indent);
        setText(exampleText);
        setReqBody({
            tableName: tableName,
            json: exampleText,
            dialect:dialect,
            multiRow: multiRow,
            includeColumns: includeColumns
        });
    };


    const handleImport = (filecontent) => {
        setText(filecontent);

        setReqBody({
            tableName: tableName,
            json: filecontent,
            dialect:dialect,
            multiRow: multiRow,
            includeColumns: includeColumns
        });
    };

    return (
        <>
            <Col>
                <ToolHeader title="JSON to SQL" description="Convert a JSON array of objects into SQL INSERT statements" toolFav={toolFav} />

                <Row >
                    <Col className="sql-toolbar">
                        {/* Table Name */}
                        <div className="SQLDropdownWrapper">
                            <label className="toolbar-label">Table Name</label>
                            <input
                                type="text"
                                value={tableName}
                                onChange={(e) => handleTableNameChange(e.target.value)}
                                className="SQLDropdownToggle"
                            />
                        </div>

                        {/* Dialect */}
                        <div className="SQLDropdownWrapper" ref={dialectDropdownRef}>
                            <label className="toolbar-label">DIALECT</label>
                            <button
                                type="button"
                                className="SQLDropdownToggle"
                                onClick={() => setShowDialectDropdown((prev) => !prev)}
                            >
                                <span className="SQLDropdownText">{dialect === "" ? 'Select Dialect' : dialect} <CaretDownIcon /></span>
                            </button>
                            {showDialectDropdown && (
                                <div className="SQLDropdownMenu">
                                    {dialectOptions.map((value) => (
                                        <button
                                            key={value}
                                            type="button"
                                            className="SQLDropdownItem"
                                            onClick={() => {
                                                setDialect(value);
                                                setShowDialectDropdown(false);
                                            }}
                                        >
                                            {value}
                                        </button>
                                    ))}
                                </div>
                            )}
                        </div>


                        {/* Checkboxes */}
                        <div className="toolbar-options">
                            <label className="checkbox-wrapper">
                                <input
                                    type="checkbox"
                                    checked={multiRow}
                                    onChange={() => setMultiRow(!multiRow)}
                                />
                                <span>Mulit- row</span>
                            </label>

                            <label className="checkbox-wrapper">
                                <input
                                    type="checkbox"
                                    checked={createTable}
                                    onChange={() => setCreateTable(!createTable)}
                                />
                                <span>Create Table</span>
                            </label>

                            <label className="checkbox-wrapper">
                                <input
                                    type="checkbox"
                                    checked={includeColumns}
                                    onChange={() => setIncludeColumns(!includeColumns)}
                                />
                                <span>Include Columns</span>
                            </label>
                        </div>

                        {/* Button */}
                        <button className="ExecuteButton" onClick={generateSQL}>
                            ↻ Generate SQL
                        </button>
                    </Col>
                </Row>

                <Row className='Formatter json-formatter-row'>
                    <Col xs={12} lg={6} className="json-formatter-column">
                        <FormatterPanel
                            title="Input JSON"
                            value={text}
                            onChange={(e) => handleChange(e)}
                            placeholder="Paste your JSON here..."
                            lineCount={lineCount}
                            headerButtons={
                                <InputHeaderButtons
                                    primaryLabel="Example"
                                    onPrimary={pasteExample}
                                    onClear={() => {
                                        setText("");
                                        setresult("");
                                        setReqBody('');
                                    }}
                                    onImport={(fileContent) => handleImport(fileContent)}
                                    accept=".json"
                                />
                            }
                            footerLeft={`Characters : ${text.replaceAll(" ", "").length}`}
                            footerRight={`Size : ${new Blob([text]).size} B`}
                        />
                    </Col>
                    <Col xs={12} lg={6} className="json-formatter-column">
                        <FormatterPanel
                            title="SQL Output"
                            value={result ?? ""}
                            placeholder="SQL output will appear here..."
                            lineCount={resultLineCount}
                            readOnly
                            headerButtons={
                                <OutputHeaderButtons
                                    outputText={result ?? ""}
                                    fileName="formatted.json"
                                    mimeType="application/json;charset=utf-8"
                                />
                            }
                            footerLeft={`Characters : ${result.replaceAll(" ", "").length}`}
                            footerRight={`Size : ${new Blob([result ?? ""]).size} B`}
                        />
                    </Col>
                </Row>
            </Col >
        </>
    )
}

export default JSONtoSQLConverter;
